import { upperFirst } from 'lodash';

const DOCTYPES_BY_SOLUTION_AND_TEMPLATE = {
	// Plop: doctype - add solution
	main: {
		// Plop: doctype - add main doctype
		subsiteEmployee: () =>
			import(
				/* webpackChunkName: "main__doctypeEmployeePage" */ '~/doctypes/main/EmployeePage.vue'
			),

		loginPage: () =>
			import(
				/* webpackChunkName: "main__doctypeLoginPage" */ '~/doctypes/main/LoginPage.vue'
			),
		searchPage: () =>
			import(
				/* webpackChunkName: "main__doctypeSearchPage" */ '~/doctypes/main/SearchPage.vue'
			),
		expertList: () =>
			import(
				/* webpackChunkName: "main__doctypeEmployeeList" */ '~/doctypes/main/EmployeeList.vue'
			),
		subsiteEmployeeList: () =>
			import(
				/* webpackChunkName: "main__doctypeEmployeeList" */ '~/doctypes/main/EmployeeList.vue'
			),
		subsiteProjectList: () =>
			import(
				/* webpackChunkName: "main__doctypeProjectList" */ '~/doctypes/main/ProjectList.vue'
			),
		subsitePublicationList: () =>
			import(
				/* webpackChunkName: "main__doctypePublicationList" */ '~/doctypes/main/PublicationList.vue'
			),
		subsiteFrontPage: () =>
			import(
				/* webpackChunkName: "main__doctypeFrontpage" */ '~/doctypes/main/Frontpage.vue'
			),
		eventPage: () =>
			import(
				/* webpackChunkName: "main__doctypeEventPage" */ '~/doctypes/main/EventPage.vue'
			),
		eventList: () =>
			import(
				/* webpackChunkName: "main__doctypeEventList" */ '~/doctypes/main/EventList.vue'
			),
		subsiteNewsList: () =>
			import(
				/* webpackChunkName: "main__doctypeNewsList" */ '~/doctypes/main/NewsList.vue'
			),
		area: () =>
			import(
				/* webpackChunkName: "main__doctypeContentPage" */ '~/doctypes/main/ContentPage.vue'
			),
		subsiteContentPage: () =>
			import(
				/* webpackChunkName: "main__doctypeContentPage" */ '~/doctypes/main/ContentPage.vue'
			),
		subsiteNewsPage: () =>
			import(
				/* webpackChunkName: "main__doctypeContentPage" */ '~/doctypes/main/ContentPage.vue'
			),
		subsiteProject: () =>
			import(
				/* webpackChunkName: "main__doctypeContentPage" */ '~/doctypes/main/ContentPage.vue'
			),
		subsitePublication: () =>
			import(
				/* webpackChunkName: "main__doctypeContentPage" */ '~/doctypes/main/ContentPage.vue'
			),
		subsiteThemePage: () =>
			import(
				/* webpackChunkName: "main__doctypeContentPage" */ '~/doctypes/main/ContentPage.vue'
			),
		overviewList: () =>
			import(
				/* webpackChunkName: "main__doctypeOverviewList" */ '~/doctypes/main/OverviewList.vue'
			),
		areaList: () =>
			import(
				/* webpackChunkName: "main__doctypeOverviewList" */ '~/doctypes/main/OverviewList.vue'
			),
		subsiteThemeOverviewList: () =>
			import(
				/* webpackChunkName: "main__doctypeOverviewList" */ '~/doctypes/main/OverviewList.vue'
			),
	},
	shared: {
		// Plop: doctype - add shared doctype
	},
};

export const getDoctypeFromSolutionAndTemplate = (solution, template) =>
	upperFirst(`${upperFirst(template)}`);

// format that allows local registration via `components`
export default Object.entries(DOCTYPES_BY_SOLUTION_AND_TEMPLATE).reduce(
	(acc, [solution, doctypesByTemplate]) => ({
		...acc,

		...Object.entries(doctypesByTemplate).reduce(
			(acc, [template, doctype]) => ({
				...acc,

				[getDoctypeFromSolutionAndTemplate(solution, template)]:
					doctype,
			}),
			{}
		),
	}),
	{}
);
